import * as React from 'react';
import { Option, useFieldState } from "informed";

import { DataItemImportance } from '../../misc/api/apiTypes';
import Condition from '../../misc/components/Condition';
import { Dropdown } from './Dropdown';
import { Required } from '../validation/Required';
import { useCurrentStudyConfigurationContext } from '../../Core/CurrentStudyConfigurationContext';
import { inputClasses } from '../validation/ValidationClasses';
import { ConfigurableDataItemIds } from '../../misc/api/ApiConfigurableDataItems';

interface ConfigFieldDropdownProps {
    id: string;
    field: string;
    className: string;
    disabled?: boolean;
    required: boolean;
    itemId: ConfigurableDataItemIds;
    showBlankOption?: boolean;
    defaultValue?: string;
    children: any;
}

export const ConfigFieldDropdown = (props: ConfigFieldDropdownProps): JSX.Element => {
    const {
        id,
        field,
        className,
        disabled,        
        required,
        itemId,
        showBlankOption = true,
        children
    } = props;

    const { dataItemConfigurationCollection } = useCurrentStudyConfigurationContext();

    const fieldState = useFieldState(field);

    if (dataItemConfigurationCollection === null || dataItemConfigurationCollection === undefined)
        throw 'Fields Configurations is not set';

    const item = dataItemConfigurationCollection.find(x => x.configurableDataItemId === itemId);

    return <>
        <Condition test={() => item.importanceId !== DataItemImportance.NotApplicable}>
            <div className={className} data-automationid={`${id}-form-group`}>
                <label htmlFor={id}>{item.displayText}</label>
                <Dropdown
                    id={id}
                    field={field}
                    disabled={disabled}
                    className={inputClasses(fieldState.error)}
                    validate={required ? item.importanceId === DataItemImportance.Mandatory ? Required : null : null}
            >
                    {showBlankOption ? <Option
                        key={"OptionSiteBlank"}
                        value={[]}
                    /> : null}
                    {children}
                </Dropdown>
            </div>
        </Condition>
    </>
}
